import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getFirebaseErrorMessage } from '../utils/helpers';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn, checkAdminStatus } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await signIn(email, password);
    
    if (result.success) {
      const isAdminUser = await checkAdminStatus(result.user);
      if (isAdminUser) {
        navigate('/admin/dashboard');
      } else {
        setError('Unauthorized access. Admin credentials required.');
        setLoading(false);
      }
    } else {
      setError(getFirebaseErrorMessage(result.error));
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div style={{ background: 'white', padding: '2rem', borderRadius: '20px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', maxWidth: '400px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src="/images/logo.png" alt="Logo" style={{ width: '80px', marginBottom: '1rem' }} />
          <h1 style={{ marginBottom: '0.5rem' }}>Admin Panel</h1>
          <p style={{ color: '#6c757d' }}>Offer Lifetime Management System</p>
        </div>
        
        {error && (
          <div className="alert alert-danger">{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@offerlifeline.com"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Logging in...' : 'Login to Dashboard'}
          </button>
        </form>

        <p style={{ marginTop: '1.5rem', textAlign: 'center', fontSize: '0.875rem', color: '#6c757d' }}>
          Protected Area - Authorized Access Only
        </p>

        <p style={{ marginTop: '0.5rem', textAlign: 'center' }}>
          <Link to="/" style={{ color: '#6c757d' }}>← Back to Home</Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
